import React, { useEffect, useState } from "react";
import DefaultLayout from "../reusableComponents/defaultLayout";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import { toast } from "react-toastify";
import Notes from "../components/notes";
import Ratting from "../components/rating";
import { ThreeDots } from "react-loader-spinner";
import Chat from "../components/chat";
import AccountHeader, { subContractorTabs } from "../components/account/AccountHeader";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DescriptionIcon from '@mui/icons-material/Description';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ImageIcon from '@mui/icons-material/Image';
import ChatIcon from '@mui/icons-material/Chat';
import NoteIcon from '@mui/icons-material/Note';
import SendIcon from '@mui/icons-material/Send';
import { API_BASE_URL } from '../config/api';

const Loader = () => <ThreeDots height="20" width="40" color="#fff" />;

export default function Startprojectdetail() {
    const [projectsDetials, setProjectsDetials] = useState({});
    const [openNotesIndex, setOpenNotesIndex] = useState(null);
    const [openChatIndex, setOpenChatIndex] = useState(null);
    const [isUser, setIsUser] = useState(false);
    const [projectsBidding, setBiddingDetials] = useState([]);
    const [loadingIndex, setLoadingIndex] = useState(null);
    const [loading, setLoading] = useState(false);
    const [awarded, setAwarded] = useState(false);
    const [isNotesAdded, setisNotesAdded] = useState(false);
    const [chatRefresh, setChatRefresh] = useState(false);

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const isPending = searchParams.get('pending');
    const { id, activeProjects } = useParams();

    const userId = useSelector((state) => state?.userProfileSlice?.userData?.data?.id);
    const userRole = useSelector((state) => state?.userProfileSlice?.userData?.data?.role);

    const handleRefresh = () => setChatRefresh(true);
    const updateFlag = (notesAdded) => setisNotesAdded(notesAdded);

    const showNotes = (index) => {
        setOpenChatIndex(null);
        setOpenNotesIndex(index);
    };

    const showChat = (index) => {
        setOpenChatIndex(index);
        setOpenNotesIndex(null);
    };

    const showChatForActiveBid = () => {
        setOpenChatIndex(1);
        setOpenNotesIndex(null);
    };

    const showNotesForActiveBid = () => {
        setOpenChatIndex(null);
        setOpenNotesIndex(1);
    };

    const fetchProjectData = async () => {
        setLoading(true);
        const url = API_BASE_URL;
        const token = localStorage.getItem("authToken");
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };

        try {
            const response = await fetch(`${url}/project_detail/${id}`, requestOptions);
            if (!response.ok) throw new Error("Failed to fetch project details");
            const data = await response.json();
            setProjectsDetials(data?.data);
        } catch (error) {
            console.error("Error fetching project details:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchBiddingData = async () => {
        const url = API_BASE_URL;
        const token = localStorage.getItem("authToken");
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        try {
            const res = await fetch(`${url}/bid_listing?project_id=${id}`, requestOptions);
            const body = await res.json();
            setBiddingDetials(body?.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleAward = async (item, index) => {
        try {
            setLoadingIndex(index);
            setAwarded(true);
            const url = API_BASE_URL;
            const token = localStorage.getItem("authToken");
            const requestData = {
                project_id: item.project_id,
                bid_id: item.id,
                assigned_to: item.user_id,
            };

            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(requestData),
            };

            const res = await fetch(`${url}/accept_bid`, requestOptions);
            const body = await res.json();

            if (body.success === true) {
                toast.success("Bid awarded successfully!", { autoClose: 3000 });
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingIndex(null);
        }
    };

    useEffect(() => {
        fetchProjectData();
        setTimeout(() => fetchBiddingData(), 1000);
    }, [isNotesAdded, awarded, chatRefresh]);

    useEffect(() => {
        if (projectsDetials?.user_id == userId) {
            setIsUser(true);
        }
    }, [isUser, projectsDetials, userId]);

    const getFileNameFromURL = (url) => {
        try {
            const urlObj = new URL(url);
            const fileNameWithExtension = urlObj.pathname.split("/").pop();
            const fileNameWithoutPrefix = fileNameWithExtension.slice(13);
            const fileNameWithoutExtension = fileNameWithoutPrefix.split(".")[0];
            return fileNameWithoutExtension.length > 35
                ? `${fileNameWithoutExtension.slice(0, 35)}...`
                : fileNameWithoutExtension;
        } catch {
            return "Document";
        }
    };

    const formatValue = (value) => {
        if (!value || value === "N/A") return "N/A";
        if (value === "design_build") return "Design Build";
        if (value === "tbd") return "TBD";
        return value.charAt(0).toUpperCase() + value.slice(1);
    };

    const Handlenavigate = () => navigate(`/account/4?${id}`);

    // Detail Item Component
    const DetailItem = ({ label, value, icon: Icon }) => (
        <div className="detail_item">
            {Icon && <Icon className="detail_icon" />}
            <div className="detail_content">
                <span className="detail_label">{label}</span>
                <span className="detail_value">{value || "N/A"}</span>
            </div>
        </div>
    );

    // Proposal Card Component
    const ProposalCard = ({ item, index, showAwardButton = true }) => (
        <div className="proposal_card">
            <div className="proposal_card_header">
                <div className="proposal_user">
                    <div className="user_avatar">
                        <PersonIcon />
                    </div>
                    <div className="user_info">
                        <h4>{item?.user?.fname || "Unknown"}</h4>
                        <span>Submitted {moment(item?.created_at).format("MMM D, YYYY")}</span>
                    </div>
                </div>
                {showAwardButton && (
                    <div className="proposal_status">
                        {item.status === "hired" ? (
                            <span className="status_badge awarded">Awarded</span>
                        ) : item.status === "pending" ? (
                            <button
                                onClick={() => handleAward(item, index)}
                                className="award_btn"
                                disabled={loadingIndex === index}
                            >
                                {loadingIndex === index ? <Loader /> : "Award Project"}
                            </button>
                        ) : (
                            <span className="status_badge rejected">Rejected</span>
                        )}
                    </div>
                )}
            </div>

            <div className="proposal_card_body">
                <div className="proposal_section">
                    <h5>Comments</h5>
                    <p>{item?.description || "No comments provided"}</p>
                </div>

                <div className="proposal_section">
                    <h5 className="clickable" onClick={() => showChat(index)}>
                        <ChatIcon fontSize="small" /> Latest Communication
                    </h5>
                    <p>
                        {item?.latest_chat?.message
                            ? item.latest_chat.message.length > 200
                                ? `${item.latest_chat.message.slice(0, 200)}...`
                                : item.latest_chat.message
                            : "No messages yet"}
                    </p>
                </div>

                <div className="proposal_documents">
                    <div className="documents_column">
                        <h5><InsertDriveFileIcon fontSize="small" /> Proposal Documents</h5>
                        {item?.files?.length > 0 ? (
                            <ul className="file_list">
                                {item.files.map((file, idx) => (
                                    <li key={idx}>
                                        <a href={file?.plan_doc} target="_blank" rel="noreferrer">
                                            {getFileNameFromURL(file?.plan_doc)}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="no_files">No documents</p>
                        )}
                    </div>

                    <div className="documents_column">
                        <h5><InsertDriveFileIcon fontSize="small" /> Additional Documents</h5>
                        {item?.additionalfiles?.length > 0 ? (
                            <ul className="file_list">
                                {item.additionalfiles.map((file, idx) => (
                                    <li key={idx}>
                                        <a href={file?.additional_doc} target="_blank" rel="noreferrer">
                                            {getFileNameFromURL(file?.additional_doc)}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="no_files">No documents</p>
                        )}
                    </div>
                </div>

                <div className="proposal_footer">
                    <div className="rating_section">
                        <Ratting bidData={item} />
                    </div>
                    <div className="notes_section" onClick={() => showNotes(index)}>
                        <h5 className="clickable"><NoteIcon fontSize="small" /> Notes</h5>
                        <p>{item?.latest_notes?.notes || "No notes"}</p>
                    </div>
                </div>
            </div>

            {openChatIndex === index && (
                <Chat setOpenChatIndex={setOpenChatIndex} bidData={item} onChatClose={handleRefresh} />
            )}
            {openNotesIndex === index && (
                <Notes setOpenNotesIndex={setOpenNotesIndex} bidData={item} updateFlag={updateFlag} />
            )}
        </div>
    );

    // Determine which tabs to show based on user role
    const isSubContractor = userRole === 'sub_contractor';

    return (
        <DefaultLayout>
            <AccountHeader tabs={isSubContractor ? subContractorTabs : undefined} />

            <div className="profile_page">
                <div className="container">
                    <button className="back_link" onClick={() => navigate(-1)}>
                        <ArrowBackIcon fontSize="small" /> Back
                    </button>

                    {loading ? (
                        <div className="profile_section">
                            <div className="loading_state">
                                <ThreeDots height="60" width="80" radius="9" color="#B1903F" visible={true} />
                                <p>Loading project details...</p>
                            </div>
                        </div>
                    ) : (
                        <>
                            {/* Project Header */}
                            <div className="project_detail_header">
                                <h1>{projectsDetials?.project_name || "Project Details"}</h1>
                                {projectsDetials?.project_start_date && (
                                    <span className="project_date_badge">
                                        <CalendarTodayIcon fontSize="small" />
                                        Start: {moment(projectsDetials.project_start_date).format("MMM DD, YYYY")}
                                    </span>
                                )}
                            </div>

                            {/* Submitted Proposals (for project owners) - Moved to top */}
                            {isUser && (
                                <div className="profile_section">
                                    <div className="section_header">
                                        <div className="section_header_row">
                                            <div>
                                                <h3>Submitted Proposals</h3>
                                                <p>{projectsBidding.length} proposal{projectsBidding.length !== 1 ? 's' : ''} received</p>
                                            </div>
                                            {!projectsDetials?.assigned_to && (
                                                <button className="invite_btn" onClick={Handlenavigate}>
                                                    <SendIcon fontSize="small" /> Send Invitation
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    <div className="section_content">
                                        {projectsBidding.length === 0 ? (
                                            <div className="empty_state">
                                                <DescriptionIcon className="empty_icon" />
                                                <h4>No Proposals Yet</h4>
                                                <p>No contractors have submitted proposals for this project.</p>
                                            </div>
                                        ) : (
                                            <div className="proposals_list">
                                                {projectsBidding.map((item, index) => (
                                                    <ProposalCard key={index} item={item} index={index} />
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Awarded Proposals (for active projects) - Moved to top */}
                            {projectsDetials?.award_bid !== null && activeProjects === "true" && (
                                <div className="profile_section">
                                    <div className="section_header">
                                        <h3>Awarded Proposal</h3>
                                        <p>The winning bid for this project</p>
                                    </div>
                                    <div className="section_content">
                                        <ProposalCard 
                                            item={projectsDetials.award_bid} 
                                            index={1}
                                            showAwardButton={projectsDetials.award_bid?.status === "pending"}
                                        />
                                        {openChatIndex === 1 && (
                                            <Chat setOpenChatIndex={setOpenChatIndex} bidData={projectsDetials.award_bid} />
                                        )}
                                        {openNotesIndex === 1 && (
                                            <Notes setOpenNotesIndex={setOpenNotesIndex} bidData={projectsDetials.award_bid} updateFlag={updateFlag} />
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Pending Proposals (for bidders viewing their own bids) - Moved to top */}
                            {isPending && (
                                <div className="profile_section">
                                    <div className="section_header">
                                        <h3>Your Submitted Proposals</h3>
                                        <p>Proposals you've submitted for this project</p>
                                    </div>
                                    <div className="section_content">
                                        {projectsBidding.filter(item => item.user_id === userId).length === 0 ? (
                                            <div className="empty_state">
                                                <DescriptionIcon className="empty_icon" />
                                                <h4>No Proposals Submitted</h4>
                                                <p>You haven't submitted any proposals for this project yet.</p>
                                            </div>
                                        ) : (
                                            <div className="proposals_list">
                                                {projectsBidding
                                                    .filter(item => item.user_id === userId)
                                                    .map((item, index) => (
                                                        <ProposalCard key={index} item={item} index={index} showAwardButton={false} />
                                                    ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Project Information */}
                            <div className="profile_section">
                                <div className="section_header">
                                    <h3>Project Information</h3>
                                    <p>Basic details about this project</p>
                                </div>
                                <div className="section_content">
                                    <div className="details_grid">
                                        <DetailItem label="Project Name" value={projectsDetials?.project_name} icon={DescriptionIcon} />
                                        <DetailItem label="Email" value={projectsDetials?.email} icon={EmailIcon} />
                                        <DetailItem label="Project Rep" value={projectsDetials?.project_rep} icon={PersonIcon} />
                                        <DetailItem label="Phone Number" value={projectsDetials?.phone} icon={PhoneIcon} />
                                    </div>
                                </div>
                            </div>

                            {/* Project Description */}
                            <div className="profile_section">
                                <div className="section_header">
                                    <h3>Project Description</h3>
                                </div>
                                <div className="section_content">
                                    <p className="description_text">{projectsDetials?.project_description || "No description provided"}</p>
                                    
                                    {projectsDetials?.past_work && (
                                        <div className="past_work_section">
                                            <h4>Past Work Experience</h4>
                                            <p>{projectsDetials.past_work}</p>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Timeline & Team */}
                            <div className="profile_section">
                                <div className="section_header">
                                    <h3>Timeline & Team</h3>
                                    <p>Project schedule and team members</p>
                                </div>
                                <div className="section_content">
                                    <div className="details_grid">
                                        <DetailItem label="Start Date" value={projectsDetials?.project_start_date} icon={CalendarTodayIcon} />
                                        <DetailItem label="Completion Date" value={projectsDetials?.project_end_date} icon={CalendarTodayIcon} />
                                        <DetailItem label="Designer" value={formatValue(projectsDetials?.designer)} />
                                        <DetailItem label="Engineer" value={formatValue(projectsDetials?.engineer)} />
                                        <DetailItem label="Architect" value={formatValue(projectsDetials?.architect)} />
                                        <DetailItem label="Financing" value={formatValue(projectsDetials?.financing)} />
                                    </div>
                                </div>
                            </div>

                            {/* Documents & Plans */}
                            <div className="profile_section">
                                <div className="section_header">
                                    <h3>Documents & Plans</h3>
                                    <p>Project permits, plans, and images</p>
                                </div>
                                <div className="section_content">
                                    <div className="documents_section">
                                        {/* Permits */}
                                        <div className="document_group">
                                            <h4><InsertDriveFileIcon fontSize="small" /> Permits</h4>
                                            {projectsDetials?.permit_doc?.length > 0 ? (
                                                <ul className="document_list">
                                                    {projectsDetials.permit_doc.map((data, index) => (
                                                        <li key={index}>
                                                            <a href={data.document_name} target="_blank" rel="noreferrer">
                                                                {getFileNameFromURL(data.document_name)}
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <p className="no_documents">No permits uploaded</p>
                                            )}
                                        </div>

                                        {/* Plans */}
                                        <div className="document_group">
                                            <h4><InsertDriveFileIcon fontSize="small" /> Plans ({formatValue(projectsDetials?.plan)})</h4>
                                            {projectsDetials?.plan_doc?.length > 0 ? (
                                                <ul className="document_list">
                                                    {projectsDetials.plan_doc.map((data, index) => (
                                                        <li key={index}>
                                                            <a href={data.document_name} target="_blank" rel="noreferrer">
                                                                {getFileNameFromURL(data.document_name)}
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <p className="no_documents">No plans uploaded</p>
                                            )}
                                        </div>
                                    </div>

                                    {/* Project Images */}
                                    {projectsDetials?.plan_image?.length > 0 && (
                                        <div className="images_section">
                                            <h4><ImageIcon fontSize="small" /> Project Images</h4>
                                            <div className="images_grid">
                                                {projectsDetials.plan_image.map((data, index) => (
                                                    <a key={index} href={data.image_name} target="_blank" rel="noreferrer" className="image_item">
                                                        <img src={data.image_name} alt={`Project ${index + 1}`} />
                                                    </a>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Submit Proposal Button (for non-owners) */}
                            {!isUser && activeProjects !== "true" && (
                                <div className="profile_actions centered">
                                    <Link to={`/submitproposal/${projectsDetials?.id}`} className="save_btn">
                                        Submit Proposal For This Project
                                    </Link>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </DefaultLayout>
    );
}
